<!-- 基金分红提示 -->
<template>
  <div v-if="!$isEmpty(announceInfo)" class="box" @click="$goFundApp">
    <fund-announce
      v-for="(item, index) in announceInfo"
      :key="index"
      :content="item.content"
      :hotKeys="item.hotKey"/>
  </div>
</template>

<script>
import FundAnnounce from '../../../components/common/FundAnnounce.vue';

export default {
  name: 'bonus-tip',

  components: { FundAnnounce },

  props: {
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    announceInfo() {
      return this.detailInfo?.fundBonusPoints || [];
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  margin-bottom: 24px;
  box-sizing: border-box;
}
</style>
